import React from "react";
import { Wrapper } from "app/NativeComponents/common";
import ButtonLayout from "./ButtonLayout";

const DrivingButton = props => {
  if (props.device === "mobile" || props.isMobile) {
    if (props.track_route) {
      return (
        <ButtonLayout
          style={{
            marginRight: 0
          }}
          onPress={() => {
            if (props.current_route) {
              props.setModal({
                title: "Are you finished with your drive?",
                description:
                  "Are you sure you want to stop driving and complete your route?",
                submit: "Stop Driving",
                onPress: () => {
                  props.stopTrackedRoute({
                    token: props.token,
                    route_id: props.current_route.route_id,
                    coordinates: props.current_route_section
                      ? props.current_route_section.coordinates
                      : [],
                    current_route: props.current_route
                  });

                  if (props.route_plan_active) {
                    props.stopPlannedRoute({
                      token: props.token,
                      planned_route_id: props.planned_route_id
                    });
                  }
                },
                cancel: "Not yet",
                onCancel: () => {}
              });
              props.toggleModal({ show: true, type: "normal" });
            }
          }}
          icon="stop"
          text="Stop Driving"
        />
      );
    }

    return (
      <ButtonLayout
        style={{
          marginRight: 0
        }}
        onPress={() => {
          if (props.user.team_clearance_level >= 1) {
            props.toggleActionSheet("switch_driving_mode");
          } else {
            if (!props.track_route) {
              props.startTrackedRoute({
                token: props.token
              });
            }
          }
        }}
        icon="drive-eta"
        text="Start Driving"
      />
    );
  }

  return <Wrapper />;
};

export default React.memo(DrivingButton);
